"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Request {
    constructor() {
        const { common: { request: { bindCommonApi } } } = require('@futuweb/fego-render');
        this.commonApiRequest = bindCommonApi('self-selected-stocks');
    }
    /**
     * 获取自选股状态
     * @param stockId
     * @returns
     */
    async getStatus(stockId) {
        const res = await this.commonApiRequest.get('status', { stockId });
        if (res.code === 10002) {
            return false;
        }
        return res.data.result;
    }
    /**
     * 订阅自选股
     * @description 未考虑未登录状态，这里在页面内检测uid=0，直接跳转登录
     * @param stockId
     */
    async subscribeStock(stockId) {
        const res = await this.commonApiRequest.post('subscribeStock', {
            stockId
        });
        if (res.code === 0) {
            return true;
        }
        return false;
    }
    /**
     * 取消订阅自选股
     * @description 未考虑未登录状态，这里在页面内检测uid=0，直接跳转登录
     * @param stockId
     * @returns
     */
    async cancelSubscribeStock(stockId) {
        const res = await this.commonApiRequest.post('cancelSubscribeStock', { stockId });
        if (res.code === 0) {
            return true;
        }
        return false;
    }
}
exports.default = new Request();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlcXVlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxNQUFNLE9BQU87SUFHVDtRQUNJLE1BQU0sRUFDRixNQUFNLEVBQUUsRUFDSixPQUFPLEVBQUUsRUFBRSxhQUFhLEVBQUUsRUFDN0IsRUFDSixHQUFHLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO1FBQ3BDLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxhQUFhLENBQUMsc0JBQXNCLENBQUMsQ0FBQztJQUNsRSxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLEtBQUssQ0FBQyxTQUFTLENBQUMsT0FBZTtRQUNsQyxNQUFNLEdBQUcsR0FBK0MsTUFBTSxJQUFJLENBQUMsZ0JBQWdCLENBQUMsR0FBRyxDQUFDLFFBQVEsRUFBRSxFQUFFLE9BQU8sRUFBRSxDQUFDLENBQUM7UUFDL0csSUFBSSxHQUFHLENBQUMsSUFBSSxLQUFLLEtBQUssRUFBRTtZQUNwQixPQUFPLEtBQUssQ0FBQztTQUNoQjtRQUNELE9BQU8sR0FBRyxDQUFDLElBQUssQ0FBQyxNQUFNLENBQUM7SUFDNUIsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxLQUFLLENBQUMsY0FBYyxDQUFDLE9BQWU7UUFDdkMsTUFBTSxHQUFHLEdBQWtELE1BQU0sSUFBSSxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxnQkFBZ0IsRUFBRTtZQUMxRyxPQUFPO1NBQ1YsQ0FBQyxDQUFDO1FBQ0gsSUFBSSxHQUFHLENBQUMsSUFBSSxLQUFLLENBQUMsRUFBRTtZQUNoQixPQUFPLElBQUksQ0FBQztTQUNmO1FBQ0QsT0FBTyxLQUFLLENBQUM7SUFDakIsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksS0FBSyxDQUFDLG9CQUFvQixDQUFDLE9BQWU7UUFDN0MsTUFBTSxHQUFHLEdBQWtELE1BQU0sSUFBSSxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FDdkYsc0JBQXNCLEVBQ3RCLEVBQUUsT0FBTyxFQUFFLENBQ2QsQ0FBQztRQUNGLElBQUksR0FBRyxDQUFDLElBQUksS0FBSyxDQUFDLEVBQUU7WUFDaEIsT0FBTyxJQUFJLENBQUM7U0FDZjtRQUNELE9BQU8sS0FBSyxDQUFDO0lBQ2pCLENBQUM7Q0FDSjtBQUVELGtCQUFlLElBQUksT0FBTyxFQUFFLENBQUMifQ==